module.exports = __webpack_public_path__ + "fonts/Lato-LightItalic.b55e385f.woff";